module.exports = __webpack_public_path__ + "img/No data.d15f1850.gif";